import TotalGuestDayPresenter from "./TotalGuestDayPresenter";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import Export from "../../../components/Export";
import printChart from "../../../PrintChart";
import DateRange from "../../../components/DateRange";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import Select from "react-select";
import InitialPrompt from "../../../components/InitialPrompt";
import GuestCountsByDayReport from "./components/GuestCountsByDayReport";
import { exportTotalGuestsPerDayCSV } from "./utils/totalGuestsPerDayCsvUtils";
import ProgressLoader from "../../../components/ProgressLoader";
import PageHeader from "../../../components/PageHeader";
import CustomSelect from "../../../components/CustomSelect";
import DateRangeReport from "../../../components/DateRangeReport";

class TotalGuestDayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalGuestDayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );

    return [...new Set(storeCodes)];
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value });
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions() {
    const { objects, startDate, endDate, selectedStoreCode } = this.state;

    return objects
      .filter((obj) => obj.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);
        const start = startDate
          ? new Date(startDate)
          : new Date(-8640000000000000);
        const end = endDate ? new Date(endDate) : new Date();
        end.setHours(23, 59, 59, 999);
        const isDateInRange =
          (!startDate || transactionDate >= start) &&
          (!endDate || transactionDate <= end);
        const isStoreCodeMatch = selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            selectedStoreCode
          : true;

        return isDateInRange && isStoreCodeMatch;
      });
  }

  countTransactionTypesPerDayOfWeek = (transactions) => {
    const counts = {
      solo: new Array(7).fill(0),
      couple: new Array(7).fill(0),
      smallGroup: new Array(7).fill(0),
      meduimGroup: new Array(7).fill(0),
      largeGroup: new Array(7).fill(0),
    };

    transactions.forEach((transaction) => {
      const dayOfWeek = new Date(transaction.tran_date).getDay();
      switch (transaction.cust_count) {
        case "1":
          counts.solo[dayOfWeek]++;
          break;
        case "2":
          counts.couple[dayOfWeek]++;
          break;
        case "3":
        case "4":
        case "5":
          counts.smallGroup[dayOfWeek]++;
          break;
        case "6":
        case "7":
        case "8":
        case "9":
        case "10":
          counts.meduimGroup[dayOfWeek]++;
          break;
        case "11":
        case "12":
        case "13":
        case "14":
        case "15":
          counts.largeGroup[dayOfWeek]++;
          break;
        default:
          break;
      }
    });

    return counts;
  };

  getChartData() {
    const filteredTransactions = this.filterTransactions();
    const newCounts = this.countTransactionTypesPerDayOfWeek(
      filteredTransactions,
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear(),
    );

    const labels = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    return {
      labels,
      datasets: [
        { label: "Solo", data: newCounts.solo },
        { label: "Couple", data: newCounts.couple },
        { label: "Small Group", data: newCounts.smallGroup },
        { label: "Medium Group", data: newCounts.meduimGroup },
        { label: "Large Group", data: newCounts.largeGroup },
      ],
    };
  }

  getHighchartsOptions(chartData) {
    return {
      chart: { type: "column" },
      title: { text: null },
      xAxis: {
        categories: chartData.labels,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: { text: "Guest Count" },
        stackLabels: { enabled: true },
      },
      tooltip: {
        headerFormat: "<b>{point.x}</b><br/>",
        pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
      },
      plotOptions: {
        column: {
          stacking: "normal",
          borderRadius: 3,
        },
      },
      series: [
        {
          name: "Solo (1)",
          data: chartData.datasets[0].data,
          color: "#1b74bb",
        },
        {
          name: "Couple (2)",
          data: chartData.datasets[1].data,
          color: "#ffcd56",
        },
        {
          name: "Small Group (3-5)",
          data: chartData.datasets[2].data,
          color: "#4bc0c0",
        },
        {
          name: "Medium Group (5-10)",
          data: chartData.datasets[3].data,
          color: "#344054",
        },
        {
          name: "Large Group (11-15)",
          data: chartData.datasets[4].data,
          color: "#d0d5dd",
        },
      ],
      credits: { enabled: false },
    };
  }

  exportToCSV = () => {
    const filtered = this.filterTransactions(this.state.objects);
    exportTotalGuestsPerDayCSV(filtered, this.state.storess || "All Stores");
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, selectedStoreCode, range, storess } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getHighchartsOptions(chartData);
    const chartId = "chart-container13";

    const storeOptions = [
      { value: "AllStore", label: "All Store" },
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode,
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <PageHeader
            title="Total Guest vs. Day of Week"
            subtitle="Guest count distribution by day of the week"
            icon="bi bi-calendar-week"
          />

          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>

          <div className="col-sm-4">
            <div className="col-sm-12">
              <CustomSelect
                label="Store"
                options={[
                  // { value: "AllStore", label: "All Store" },
                  ...this.state.store.map((store) => ({
                    value: store.name,
                    label: store.name.replace(/_/g, " "),
                  })),
                ]}
                onChange={(selected) => this.onChangeStore(selected.value)}
                isDisabled={!this.state.range}
                error={
                  !this.state.range ? "Please select a date range first" : ""
                }
                icon="bi bi-shop"
                placeholder="Select Store"
                isClearable={true}
              />
            </div>
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <GuestCountsByDayReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            range={range}
            chartRef={this.chartRef13}
            containerId="chart-container13"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TotalGuestDayPage);
